import { h } from 'preact';
import ProductCard from 'utils/product-card';

const SearchProducts = ({ searchProducts, ...props }) => (
  <div className="grid grid-cols-2 gap-x-12 gap-y-20 px-15 pb-20 l:grid-cols-4 l:px-0 l:pb-0">
    {searchProducts.map((product) => (
      <ProductCard
        key={product.id}
        product={product}
        template={'search'}
        {...props}
      />
    ))}
  </div>
);

export default SearchProducts;
